document.addEventListener("DOMContentLoaded", () => {

    const header = document.querySelector(".nodotto-header");

    const button = document.querySelector(".nodotto-mobile-button");

    const mobileMenu = document.querySelector(".nodotto-mobile-menu");

    // HEADER SCROLL

    function updateHeader(){

        if(window.scrollY > 60){

            header.classList.add("scrolled");

        }else{

            header.classList.remove("scrolled");

        }

    }

    updateHeader();

    window.addEventListener("scroll", updateHeader);

    // MOBILE MENU

    if(button && mobileMenu){

        button.addEventListener("click",()=>{

            mobileMenu.classList.toggle("active");

            button.classList.toggle("active");

        });

    }

    // CHIUDE IL MENU

    document.querySelectorAll(".nodotto-mobile-menu a").forEach(link=>{

        link.addEventListener("click",()=>{

            mobileMenu.classList.remove("active");

            button.classList.remove("active");

        });

    });

});